import _objectKeysInternal from "../internals/object-keys-internal";
import _enumBugKeys from "../internals/enum-bug-keys";
var exports = {};
var internalObjectKeys = _objectKeysInternal;
var enumBugKeys = _enumBugKeys;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};
export default exports;